// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_51684b', '__Poppins_Fallback_51684b'","fontStyle":"normal"},"className":"__className_51684b","variable":"__variable_51684b"};